<template>
  <div>
    <my-header/>

    <div class="race-box">

      <b-breadcrumb>
        <b-breadcrumb-item :to="{name:'rushes'}">Ражи</b-breadcrumb-item>
        <b-breadcrumb-item :to="{name:'rush_info'}">Раж {{rushId}}</b-breadcrumb-item>
      </b-breadcrumb>

      <h2>Заезд {{raceId}}</h2>

      <div class="section-container">
        <side-nav
          :menuItems="menuItems"
          class="side-nav"
        />

        <div class="content-box">
          <router-view></router-view>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'RushRace',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    rushRaceId: {
      type: Object,
      required: true,
    }
  },

  computed: {
    /** @returns {number} */
    rushId() {
      return this.rushRaceId.rushId;
    },

    /** @returns {number} */
    raceId() {
      return this.rushRaceId.raceId;
    },

    menuItems() {
      return [
        {
          title: 'Информация',
          route: {name: 'rush_race_info', params: {rushRaceId: this.rushRaceId}},
        },
        {
          title: 'Игроки',
          route: {name: 'rush_race_rating', params: {rushRaceId: this.rushRaceId}},
        },
      ];
    },
  },

};
</script>

<style scoped>
.race-box {
  margin-left: 1rem;
  max-width: 600px;
}

.section-container {
  display: flex;
  align-items: flex-start;
}

.side-nav {
  margin-right: 2rem;
  background-color: rgb(242, 247, 251);
}
</style>
